import { extractApiErrorMessage } from '@/api/errors';
import {
  captureOAuthCallbackParams,
  clearEmailOauthSession,
  clearOAuthCallbackCapture,
  readCapturedOAuthCallbackParams,
} from '../api/emailOauth';
import { completeEmailOauth } from '../hooks/useEmailIntegrationConnect';

export type EmailOauthCallbackResult =
  | { status: 'missing' }
  | { status: 'error'; message: string }
  | { status: 'success' };

let inflightCallback: Promise<EmailOauthCallbackResult> | null = null;

/** Finish Gmail OAuth by POSTing `{ provider, code, state }` to the backend once. */
export async function runEmailOauthCallbackOnce(): Promise<EmailOauthCallbackResult> {
  if (inflightCallback) return inflightCallback;

  const captured = captureOAuthCallbackParams();
  if (captured.error) {
    return { status: 'error', message: captured.error };
  }

  const params = readCapturedOAuthCallbackParams();
  if (!params?.code || !params?.state) {
    return { status: 'missing' };
  }

  inflightCallback = completeEmailOauth(params)
    .then((): EmailOauthCallbackResult => {
      clearEmailOauthSession();
      clearOAuthCallbackCapture();
      return { status: 'success' };
    })
    .catch((err: unknown): EmailOauthCallbackResult => ({
      status: 'error',
      message: extractApiErrorMessage(err),
    }))
    .finally(() => {
      inflightCallback = null;
    });

  return inflightCallback;
}
